/* SAYAB — Popup trigger: 5s tras carga, 1 vez por sesión */
(function () {
  const STORAGE_KEY = 'sayab_popup_shown_v1';
  const DELAY_MS = 5000;

  function openPopup(popup) {
    // Reparentar al <body> para que position:fixed cubra todo el viewport
    // aunque un ancestro tenga transform/filter (rompe el overlay si no).
    if (popup.parentElement !== document.body) document.body.appendChild(popup);
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    const firstFocus = popup.querySelector('input[type="email"]');
    if (firstFocus) setTimeout(() => firstFocus.focus(), 150);
  }

  function closePopup(popup) {
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById('sayab-popup');
    if (!popup) return;

    let alreadyShown = false;
    try { alreadyShown = sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (e) {}

    // Si el form se acaba de enviar OK, abrir el popup para mostrar el mensaje
    const hasSuccess = popup.querySelector('.sayab-popup__success');
    if (hasSuccess) {
      openPopup(popup);
    } else if (!alreadyShown) {
      setTimeout(() => openPopup(popup), DELAY_MS);
    }

    popup.querySelectorAll('[data-sayab-popup-close]').forEach((btn) => {
      btn.addEventListener('click', () => closePopup(popup));
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) {
        closePopup(popup);
      }
    });
  });
})();
